export default {
    LOAD_INSTRUCTOR_COURSES_LIST_SUCCESS: 'LOAD_INSTRUCTOR_COURSES_LIST_SUCCESS',
    LOAD_INSTRUCTOR_COURSES_LIST_FAILURE: 'LOAD_INSTRUCTOR_COURSES_LIST_FAILURE',

    PUBLISH_COURSE_SUCCESS: 'PUBLISH_COURSE_SUCCESS',
    DELETE_COURSE_SUCCESS: 'DELETE_COURSE_SUCCESS',

    ADD_COURSE_SUCCESS: 'ADD_COURSE_SUCCESS',
    LOAD_IMPORT_COURSES_LIST_SUCCESS: 'LOAD_IMPORT_COURSES_LIST_SUCCESS',

    IMPORT_COURSE_SUCCESS: 'IMPORT_COURSE_SUCCESS',
    IMPORT_COURSE_PROGRESS: 'IMPORT_COURSE_PROGRESS',
    IMPORT_COURSE_PROGRESS_RESET: 'IMPORT_COURSE_PROGRESS_RESET',
    DOWNLOAD_COURSE_SUCCESS: 'DOWNLOAD_COURSE_SUCCESS',
    DELETE_ARCHIVE_SUCCESS: 'DELETE_ARCHIVE_SUCCESS',
    DISABLE_ARCHIVE_SUCCESS: 'DISABLE_ARCHIVE_SUCCESS',

    LOAD_INSTITUTE_LIST_SUCCESS: 'LOAD_INSTITUTE_LIST_SUCCESS',
    LOAD_DEPARTMENT_LIST_SUCCESS: 'LOAD_DEPARTMENT_LIST_SUCCESS',
    LOAD_ARCHIVE_STATUS_SUCCESS: 'LOAD_ARCHIVE_STATUS_SUCCESS'

};
